<!-- 挖矿小游戏面板：按住蓄力（力度条来回摆动）→松手敲击→矿种/产量结算 -->
<template>
    <div id="miningDiv" class="wrap">
        <el-dialog :visible.sync="miningVisible"
        :before-close="mining_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading"
         title="挖矿" :close-on-click-modal="phase !== 'charging'">
            <div class="mine-scene">
                <!-- 岩洞背景与矿脉微光 -->
                <div class="cave-glow glow1"></div>
                <div class="cave-glow glow2"></div>
                <!-- 岩壁（敲击时晃动） -->
                <div class="rock-wall" :class="{striking: phase === 'striking'}">
                    <div class="rock-face"></div>
                    <div class="rock-ore" :class="{shining: phase === 'idle' || phase === 'result'}"></div>
                </div>
                <!-- 敲击碎屑粒子 -->
                <div v-for="d in debris" :key="d.id" class="debris" :style="debrisStyle(d)"></div>
                <!-- 矿石蹦出展示：敲下矿石的庆祝动画 -->
                <div v-if="oreShow" class="ore-float">
                    <img v-if="oreShow.oreImgsrc" :src="ossPath + oreShow.oreImgsrc"
                         class="ore-img" :class="{'ore-img-rare': oreShow.rareLevel >= 2}"
                         alt="矿石">
                    <span v-else class="ore-emoji" :class="{'ore-img-rare': oreShow.rareLevel >= 2}">🪨</span>
                    <div class="ore-name" :style="{color: oreShow.rareColor}">
                        {{oreShow.oreName}} ×{{oreShow.oreCount}}
                        <span v-if="oreShow.rareLevel >= 1" class="ore-tag" :style="{color: oreShow.rareColor, borderColor: oreShow.rareColor}">{{oreShow.rareLabel}}</span>
                    </div>
                </div>
                <!-- 力度条：按住敲击按钮时来回摆动，绿色区间为最佳敲击点（随矿镐加宽） -->
                <div v-if="phase === 'charging'" class="power-wrap">
                    <div class="power-head">
                        <span class="power-label">⛏️ 力度 {{Math.round(powerValue)}}%</span>
                        <span class="power-tip">绿色区间（{{zoneStart}}%~{{zoneEnd}}%）松手敲得最准！</span>
                    </div>
                    <div class="powerbar">
                        <div class="powerbar-best" :style="powerZoneStyle"></div>
                        <div class="powerbar-fill" :class="{'powerbar-perfect': chargePerfect}" :style="{width: powerValue + '%'}"></div>
                        <div class="powerbar-marker" :style="{left: powerValue + '%'}"></div>
                    </div>
                </div>
                <!-- 状态文案 -->
                <div class="scene-text">
                    <span v-if="phase === 'idle'">幽深的矿洞里，岩壁上闪烁着金属光泽……</span>
                    <span v-else-if="phase === 'charging'" :class="{'perfect-text': chargePerfect}">{{chargePerfect ? '🌟 完美落点！快松手敲击！' : '蓄力中……看准绿区松手！'}}</span>
                    <span v-else-if="phase === 'striking'">铛——！镐头砸在岩壁上……</span>
                    <span v-else-if="phase === 'result'" :class="result && result.success ? 'success-text' : 'fail-text'">
                        <template v-if="result && result.success && result.oreName">
                            <span :style="{color: rareColor(result.rareLevel)}">【{{result.oreName}}】×{{result.oreCount}}</span>
                            <span v-if="result.rareLevel >= 2" class="rare-tag">{{rareNameMap[result.rareLevel]}}</span>
                            <span v-if="result.masteryAdd > 0" class="result-mastery">熟练度+{{result.masteryAdd}}</span>
                            <span class="result-detail">（{{result.message}}）</span>
                        </template>
                        <template v-else>{{result ? result.message : ''}}</template>
                    </span>
                </div>
            </div>

            <!-- 装备信息与选择 -->
            <div class="gear-info" v-if="phase === 'idle' || phase === 'result' || phase === 'charging'">
                <div class="gear-row gear-pick-row">
                    <span class="gear-label">⛏️ 矿镐（点击选择）：</span>
                    <div class="pick-cards">
                        <div v-for="pick in gear.picks" :key="pick.pickType"
                            class="pick-card" :class="{'pick-selected': selectedPickType === pick.pickType}"
                            @click="selectPick(pick.pickType)">
                            <div class="pick-card-head">
                                <span class="pick-card-name">{{pick.pickName}}</span>
                                <span v-if="selectedPickType === pick.pickType" class="pick-using">使用中</span>
                                <span class="pick-card-price">{{pick.price}}元</span>
                            </div>
                            <div class="pick-card-attrs">
                                <span class="pick-attr">🎯稀有 +{{pick.rareBonus}}‰</span>
                                <span class="pick-attr">🟩绿区 +{{pick.zoneBonus}}</span>
                                <span v-if="pick.extraYield" class="pick-attr">✨绿区产量+1</span>
                            </div>
                            <div class="pick-card-foot">🔩 耐久 {{pick.pickDurability}}/{{pick.pickType === 2 ? 60 : 30}}</div>
                        </div>
                        <div v-if="!gear.picks || gear.picks.length === 0" class="gear-chip gear-missing pick-empty">未装备矿镐，只能徒手敲（产量低）</div>
                    </div>
                </div>
                <div class="gear-row" v-if="!gear.hasPick">
                    <span class="gear-label">🪨 徒手：</span>
                    <span class="bait-bonus">徒手也能敲下矿石（固定1块，无矿镐加成）；探索工会补给站有矿镐出售</span>
                </div>
                <!-- 挖矿熟练度（全员开放）：熟练度逐级解锁矿种，持矿工称号再享馈赠 -->
                <div class="gear-row" v-if="gear.miner">
                    <span class="gear-label">🏆 挖矿熟练度：</span>
                    <span class="gear-chip" :class="{'gear-missing': !gear.miner.active}">
                        {{gear.miner.mastery}}/{{gear.miner.masteryLimit}}
                    </span>
                    <span class="bait-bonus" :class="{'bait-bonus-on': gear.miner.active}" :title="minerTip">
                        已掌握 {{gear.miner.unlockedCount}}/{{gear.miner.totalCount}} 种矿<template v-if="gear.miner.nextName">（下一级：{{gear.miner.nextName}} {{gear.miner.nextMastery}}）</template><template v-else>（已全部掌握）</template> · {{gear.miner.active ? '矿工馈赠：50% 概率额外+1 块' : '未持矿工称号，无馈赠'}}
                    </span>
                    <i v-if="minerTip" class="el-icon-info" style="margin-left:6px;color:#909399;" :title="minerTip"></i>
                </div>
            </div>

            <!-- 操作区 -->
            <div class="mine-actions" v-if="phase !== 'striking'">
                <el-button v-if="phase === 'idle' || phase === 'result' || phase === 'charging'" type="primary"
                    class="strike-hold-btn"
                    :disabled="cooldownLeft > 0"
                    @pointerdown.native.prevent="startCharge" @pointerup.native.prevent="releaseCharge"
                    @pointercancel.native="cancelCharge" @pointerleave.native="cancelCharge"
                    @mouseleave.native="cancelCharge">
                    {{cooldownLeft > 0 ? ('胳膊发抖中… ' + cooldownLeft + 's') : (phase === 'charging' ? (chargePerfect ? '🌟 完美！松手敲击' : '蓄力中…松手敲击！') : (phase === 'result' ? '再敲一镐' : '按住蓄力敲击'))}}
                </el-button>
                <el-button v-if="phase !== 'charging'" @click="showHandbook" :loading="handbookLoading">矿石图鉴</el-button>
                <el-button v-if="phase !== 'charging'" @click="showAchievements" :loading="achievementLoading">挖矿成就</el-button>
            </div>

            <!-- 矿石图鉴（弹窗，叠加在挖矿窗口之上） -->
            <el-dialog title="矿石图鉴" custom-class="mine-sub-dialog" width="460px"
                       :visible.sync="handbookVisible" append-to-body>
                <div class="hb-grid" v-if="handbookList != null && handbookList.length > 0">
                    <div v-for="row in handbookList" :key="row.id" class="hb-cell" :class="{'hb-locked': !row.oreCount}">
                        <img :src="ossPath + row.imgsrc" class="hb-img">
                        <span class="hb-name" :style="row.oreCount ? {color: rareColor(row.rarely)} : {}">{{row.name}}</span>
                        <span v-if="row.oreCount" class="hb-count">采集 ×{{row.oreCount}}</span>
                        <span v-else class="hb-untagged">未采集</span>
                    </div>
                </div>
                <div v-else class="noHandbook">还没有采到过矿石，先敲一镐吧！</div>
            </el-dialog>

            <!-- 挖矿成就（弹窗，叠加在挖矿窗口之上） -->
            <el-dialog title="挖矿成就" custom-class="mine-sub-dialog" width="460px"
                       :visible.sync="achievementVisible" append-to-body>
                <div class="ach-stat" v-if="achievementList.length > 0">
                    已达成 <b class="ach-done">{{achievementStat.achievedCount}}</b> · 可领取 <b class="ach-claim">{{achievementStat.claimableCount}}</b> · 已领取 <b class="ach-got">{{achievementStat.claimedCount}}</b>
                </div>
                <div v-if="achievementList.length > 0" class="ach-list">
                    <div v-for="item in achievementList" :key="item.id" class="ach-item" :class="{'ach-done-item': item.achieved, 'ach-claimed-item': item.claimed}">
                        <div class="ach-row">
                            <span class="ach-name">{{item.achievementName}}</span>
                            <span class="ach-progress" :class="{'ach-progress-done': item.achieved}">{{item.currentValue}} / {{item.targetValue}}</span>
                            <button class="ach-btn" :class="{'ach-btn-claim': item.claimable, 'ach-btn-done': item.claimed}"
                                :disabled="!item.claimable" @click="claimAchievement(item.id)">{{item.claimed ? '已领取' : (item.claimable ? '领取奖励' : '未达成')}}</button>
                        </div>
                        <div class="ach-desc">{{item.achievementDesc}} <span class="ach-reward">奖励：金币+{{item.rewardMoney}}{{item.rewardExp > 0 ? '、经验+'+item.rewardExp : ''}}</span></div>
                    </div>
                </div>
                <div v-else class="noHandbook">成就加载中…</div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import {postRequest, getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'miningPanel',
  props:{
    miningVisible: {
      type: Boolean,
      default: false
    },
    mineSpotId: String,
    fantasyUserBO: Object,
  },
  data() {
    return {
        loading: false,
        phase: 'idle',        // idle|charging|striking|result
        powerValue: 0,        // 力度值 0~100（来回摆动）
        powerDir: 1,          // 摆动方向 1升 -1降
        powerTimer: null,     // 摆动定时器
        debris: [],           // 敲击碎屑粒子 [{id,x,y,dx,dy,size,delay}]
        debrisId: 0,
        result: null,          // {success, message, oreName, oreCount, rareLevel}
        oreShow: null,         // 矿石蹦出展示 {oreName, oreImgsrc, oreCount, rareLevel, rareLabel, rareColor}
        oreShowTimer: null,
        cooldownLeft: 0,       // 敲击冷却剩余秒数（后端15s）
        cooldownTimer: null,
        handbookVisible: false,
        handbookLoading: false,
        handbookList: [],
        achievementVisible: false,
        achievementLoading: false,
        achievementList: [],
        achievementStat: {achievedCount: 0, claimableCount: 0, claimedCount: 0},
        gear: { hasPick: false, picks: [], miner: null },
        selectedPickType: null,
        // 稀有度视觉映射：0普通 1良好 2稀有 3传说
        rareColorMap: { 0: '#909399', 1: '#67c23a', 2: '#e6a23c', 3: '#f56c6c' },
        rareNameMap: { 0: '普通', 1: '良好', 2: '稀有', 3: '传说' },
    };
  },
  computed: {
    // 矿种解锁清单（悬停提示）：与渔夫面板同款，逐条标出已解锁/未解锁与所需熟练度
    minerTip() {
      const miner = (this.gear && this.gear.miner) || {};
      const ores = miner.ores || [];
      if (!ores.length) return '';
      const head = '熟练度逐级解锁矿种，满熟练才能挖出星陨；每点熟练度 +2‰ 稀有率。'
        + (miner.active ? '\n持矿工称号：得矿时 50% 概率额外+1 块（含星陨）。' : '\n未持矿工称号：无馈赠，熟练度照常累积。');
      return head + '\n' + ores.map(o => (o.unlocked ? '✔ ' : '✘ ') + o.name + '（熟练度 ' + o.mastery + '）').join('\n');
    },
    // 绿区范围：基础65-75共10点，随选中矿镐 zoneBonus 向两侧加宽（与后端 strike 判定一致）；
    // 徒手加宽 +5（60-80）——与后端 MINING_BARE_ZONE_BONUS 同口径，改动必须两侧同步
    selectedPick() {
      if (!this.selectedPickType || !this.gear.picks) return null;
      return this.gear.picks.find((x) => x.pickType === this.selectedPickType) || null;
    },
    zoneBonus() {
      return this.selectedPick ? (this.selectedPick.zoneBonus || 0) : 5;
    },
    zoneStart() {
      return 65 - this.zoneBonus;
    },
    zoneEnd() {
      return 75 + this.zoneBonus;
    },
    powerZoneStyle() {
      return { left: this.zoneStart + '%', width: (this.zoneEnd - this.zoneStart) + '%' };
    },
    chargePerfect() {
      return this.powerValue >= this.zoneStart && this.powerValue <= this.zoneEnd;
    },
  },
  watch: {
    miningVisible: {
      // immediate：组件由 v-if 创建时 prop 初始即为 true，普通 watch 不触发，导致首次打开不加载装备
      immediate: true,
      handler(newVal) {
        if (newVal === true) {
          this.resetAll();
          this.loadGear();
        }
      }
    }
  },
  beforeDestroy: function () {
    this.stopCharge();
    this.clearOreShow();
    this.stopCooldown();
  },
  methods: {
    // 装备信息（矿镐列表/矿工称号加成）
    loadGear: function() {
      getRequest('/item/mining/gear', {
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data;
                  this.gear = { hasPick: d.hasPick, picks: d.picks || [], miner: d.miner };
                  // 记住的矿镐偏好若已不存在，则默认选精钢镐（无则第一把）
                  const saved = Number(localStorage.getItem('fantasy_mining_pick_type'));
                  const types = (d.picks || []).map((x) => x.pickType);
                  if (types.indexOf(saved) >= 0) {
                    this.selectedPickType = saved;
                  } else if (types.indexOf(2) >= 0) {
                    this.selectedPickType = 2;
                  } else if (types.length > 0) {
                    this.selectedPickType = types[0];
                  } else {
                    this.selectedPickType = null;
                  }
              }
          }
      }, resp=> { /* 装备信息获取失败不打断挖矿流程 */ });
    },
    // 选择矿镐
    selectPick: function(pickType) {
      this.selectedPickType = pickType;
      localStorage.setItem('fantasy_mining_pick_type', String(pickType));
    },
    resetAll() {
      this.stopCharge();
      this.stopCooldown();
      this.phase = 'idle';
      this.result = null;
      this.clearOreShow();
      this.debris = [];
      this.handbookVisible = false;
    },
    mining_dialog_close() {
      if (this.phase === 'charging') {
        this.stopCharge();
        this.phase = 'idle';
      }
      this.clearOreShow();
      this.$emit("mining_dialog_close");
    },
    // 清除矿石展示（连同定时器）
    clearOreShow() {
      if (this.oreShowTimer) {
        clearTimeout(this.oreShowTimer);
        this.oreShowTimer = null;
      }
      this.oreShow = null;
    },
    // 蓄力：按住敲击按钮开始（力度条来回摆动）
    startCharge: function(e) {
      if (this.phase !== 'idle' && this.phase !== 'result') return;
      if (this.cooldownLeft > 0) return;
      if (!this.mineSpotId) {
        Message.error('矿点信息缺失');
        return;
      }
      // 指针捕获：蓄力期间无论布局变化/手指抖动，松开事件都送达本按钮（不会丢 releaseCharge）
      if (e && e.pointerId != null && e.target && e.target.setPointerCapture) {
        try { e.target.setPointerCapture(e.pointerId); } catch (err) {}
      }
      this.phase = 'charging';
      this.result = null;
      this.clearOreShow();
      this.powerValue = 0;
      this.powerDir = 1;
      this.stopCharge();
      this.powerTimer = setInterval(() => {
        this.powerValue += 3.2 * this.powerDir;
        if (this.powerValue >= 100) {
          this.powerValue = 100;
          this.powerDir = -1;
        } else if (this.powerValue <= 0) {
          this.powerValue = 0;
          this.powerDir = 1;
        }
      }, 30);
    },
    // 蓄力中离开按钮：取消敲击
    cancelCharge: function() {
      if (this.phase !== 'charging') return;
      this.stopCharge();
      this.phase = 'idle';
    },
    stopCharge: function() {
      if (this.powerTimer) {
        clearInterval(this.powerTimer);
        this.powerTimer = null;
      }
    },
    // 松手敲出：按当前力度值敲击
    releaseCharge: function() {
      if (this.phase !== 'charging') return;
      this.stopCharge();
      this.doStrike(Math.round(this.powerValue));
    },
    // 敲击：播放敲击动画后提交后端结算
    doStrike: function(power) {
      if (!this.mineSpotId) {
        Message.error('矿点信息缺失');
        return;
      }
      this.phase = 'striking';
      this.result = null;
      this.playStrikeAnim();
      postRequest('/item/mining/strike', {
        spotId: this.mineSpotId,
        pickType: this.selectedPickType || 1,
        power: (null == power || power < 0) ? 70 : power
      }).then(resp=> {
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data || {};
                  this.result = {
                    success: true,
                    message: respData.message,
                    oreName: d.oreName || null,
                    oreCount: d.oreCount || 0,
                    rareLevel: d.rareLevel,
                    masteryAdd: d.masteryAdd || 0
                  };
                  // 矿石蹦出展示
                  this.clearOreShow();
                  if (d.oreName) {
                    this.oreShow = {
                      oreName: d.oreName,
                      oreImgsrc: d.oreImgsrc,
                      oreCount: d.oreCount,
                      rareLevel: d.rareLevel || 0,
                      rareLabel: d.rareLabel || this.rareNameMap[d.rareLevel] || '',
                      rareColor: d.rareColor || this.rareColorMap[d.rareLevel] || '#fff'
                    };
                    this.oreShowTimer = setTimeout(() => {
                      this.oreShow = null;
                    }, 3200);
                  }
                  this.startCooldown();
              } else {
                  this.result = {success: false, message: respData.message};
                  this.phase = 'result';
                  Message.error(respData.message);
                  return;
              }
          } else {
              this.result = {success: false, message: '用户非法⊙﹏⊙∥!'};
              this.phase = 'result';
              Message.error('用户非法⊙﹏⊙∥!');
              return;
          }
          this.phase = 'result';
          // 结算完成后刷新装备与矿工加成（采矿熟练度+1、稀有矿石+2，矿镐耐久也会变化）
          this.loadGear();
          // 挖矿消耗体力疲劳，刷新玩家属性
          this.$store.dispatch('user/fetchUserDetail');
      }, resp=> {
          this.result = {success: false, message: '敲击异常，请重试'};
          this.phase = 'result';
      });
    },
    // 敲击动画：岩壁晃动 + 碎屑粒子飞散
    playStrikeAnim: function() {
      this.debris = [];
      for (let i = 0; i < 8; i++) {
        this.debris.push({
          id: ++this.debrisId,
          x: 38 + Math.random() * 24,
          y: 30 + Math.random() * 30,
          dx: (Math.random() - 0.5) * 160,
          dy: -(40 + Math.random() * 110),
          size: 4 + Math.random() * 5,
          delay: Math.random() * 0.08
        });
      }
      // 粒子动画结束后清理（0.7s 覆盖最长延迟+动画时长）
      setTimeout(() => { this.debris = []; }, 700);
    },
    debrisStyle: function(d) {
      return {
        left: d.x + '%',
        top: d.y + '%',
        width: d.size + 'px',
        height: d.size + 'px',
        animationDelay: d.delay + 's',
        '--dx': d.dx + 'px',
        '--dy': d.dy + 'px'
      };
    },
    // 敲击冷却倒计时（后端 mining_bare_cooldown_seconds 默认10s，前端同步禁用按钮）
    startCooldown: function() {
      this.stopCooldown();
      this.cooldownLeft = 10;
      this.cooldownTimer = setInterval(() => {
        this.cooldownLeft -= 1;
        if (this.cooldownLeft <= 0) {
          this.stopCooldown();
        }
      }, 1000);
    },
    stopCooldown: function() {
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = null;
      }
      this.cooldownLeft = 0;
    },
    // 稀有度颜色
    rareColor(level) {
      return this.rareColorMap[level] || '#909399';
    },
    // 矿石图鉴（弹窗）
    showHandbook: function() {
      if (this.handbookVisible) {
        this.handbookVisible = false;
        return;
      }
      this.achievementVisible = false;
      this.handbookLoading = true;
      getRequest('/item/mining/handbook', {
      }).then(resp=> {
          this.handbookLoading = false;
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  this.handbookList = respData.data || [];
                  this.handbookVisible = true;
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('图鉴查询失败');
          }
      }, resp=> {
          this.handbookLoading = false;
          Message.error('图鉴查询异常');
      });
    },
    // 挖矿成就（弹窗）
    showAchievements: function() {
      if (this.achievementVisible) {
        this.achievementVisible = false;
        return;
      }
      this.handbookVisible = false;
      this.loadAchievements();
    },
    loadAchievements: function() {
      this.achievementLoading = true;
      getRequest('/item/mining/achievement/list', {
      }).then(resp=> {
          this.achievementLoading = false;
          if (resp.status == 200) {
              const respData = resp.data;
              if (200 == respData.status) {
                  const d = respData.data || {};
                  this.achievementList = d.list || [];
                  this.achievementStat = {
                    achievedCount: d.achievedCount || 0,
                    claimableCount: d.claimableCount || 0,
                    claimedCount: d.claimedCount || 0
                  };
                  this.achievementVisible = true;
              } else {
                  Message.error(respData.message);
              }
          } else {
              Message.error('成就查询失败');
          }
      }, resp=> {
          this.achievementLoading = false;
          Message.error('成就查询异常');
      });
    },
    // 领取成就奖励
    claimAchievement: function(achievementId) {
      postRequest('/item/mining/achievement/claim', {achievementId: achievementId}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success(resp.data.message || '领取成功');
          this.loadAchievements();
        } else {
          Message.error(resp.data.message || '领取失败');
        }
      }, () => {
        Message.error('领取异常');
      });
    },
  }
}
</script>

<style scoped>
.mine-scene {
  position: relative;
  height: 220px;
  overflow: hidden;
  border-radius: 6px;
  background: linear-gradient(180deg, #2b1d12 0%, #3e2a1a 45%, #523622 75%, #2b1d12 100%);
}
/* 矿脉微光 */
.cave-glow {
  position: absolute;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  filter: blur(18px);
  pointer-events: none;
}
.glow1 { left: 18%; top: 22%; background: rgba(255, 200, 90, 0.25); animation: glowPulse 3.2s ease-in-out infinite; }
.glow2 { right: 14%; bottom: 18%; background: rgba(120, 200, 255, 0.18); animation: glowPulse 4.1s ease-in-out infinite 0.8s; }
@keyframes glowPulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}
/* 岩壁 */
.rock-wall {
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: 180px;
  height: 150px;
}
.rock-face {
  position: absolute;
  inset: 0;
  border-radius: 12px 30px 18px 26px / 24px 14px 28px 16px;
  background:
    radial-gradient(36px 26px at 30% 28%, #6b4a2e 0 60%, transparent 61%),
    radial-gradient(30px 34px at 68% 55%, #5c3f26 0 60%, transparent 61%),
    radial-gradient(26px 20px at 45% 74%, #6e4d30 0 60%, transparent 61%),
    linear-gradient(160deg, #63452a 0%, #4a3320 55%, #3a2818 100%);
  box-shadow: inset 0 -8px 18px rgba(0,0,0,0.45), inset 0 6px 10px rgba(255,235,200,0.08), 0 10px 22px rgba(0,0,0,0.5);
}
/* 岩壁上的矿脉纹路 */
.rock-ore {
  position: absolute;
  left: 24%;
  top: 30%;
  width: 72px;
  height: 80px;
  background:
    linear-gradient(115deg, transparent 42%, rgba(255, 214, 120, 0.75) 46%, rgba(255, 235, 180, 0.9) 50%, rgba(255, 214, 120, 0.75) 54%, transparent 58%),
    linear-gradient(25deg, transparent 60%, rgba(160, 220, 255, 0.5) 64%, rgba(200, 240, 255, 0.7) 68%, transparent 72%);
  filter: drop-shadow(0 0 4px rgba(255, 214, 120, 0.4));
}
.rock-ore.shining { animation: oreShine 2.4s ease-in-out infinite; }
@keyframes oreShine {
  0%, 100% { opacity: 0.75; }
  50% { opacity: 1; filter: drop-shadow(0 0 10px rgba(255, 214, 120, 0.8)); }
}
/* 敲击时岩壁晃动 */
.rock-wall.striking { animation: rockShake 0.45s ease-out; }
@keyframes rockShake {
  0% { transform: translateX(-50%) translate(0, 0); }
  15% { transform: translateX(-50%) translate(-7px, 3px) rotate(-1.5deg); }
  35% { transform: translateX(-50%) translate(6px, -2px) rotate(1deg); }
  55% { transform: translateX(-50%) translate(-4px, 2px) rotate(-0.6deg); }
  75% { transform: translateX(-50%) translate(3px, -1px); }
  100% { transform: translateX(-50%) translate(0, 0); }
}
/* 碎屑粒子 */
.debris {
  position: absolute;
  background: linear-gradient(180deg, #a8845c, #6e4d30);
  border-radius: 2px;
  pointer-events: none;
  z-index: 4;
  animation: debrisFly 0.62s ease-out forwards;
}
@keyframes debrisFly {
  0% { opacity: 1; transform: translate(0, 0) rotate(0deg); }
  100% { opacity: 0; transform: translate(var(--dx, 0px), calc(var(--dy, -80px) + 130px)) rotate(220deg); }
}
/* 矿石蹦出展示 */
.ore-float {
  position: absolute;
  top: 26px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  z-index: 12;
  animation: oreLand 0.5s ease-out;
}
@keyframes oreLand {
  0% { opacity: 0; transform: translateX(-50%) translateY(18px) scale(0.7); }
  35% { opacity: 1; transform: translateX(-50%) translateY(-34px) scale(1.1) rotate(5deg); }
  60% { transform: translateX(-50%) translateY(4px) scale(0.98); }
  100% { transform: translateX(-50%) translateY(0) scale(1); }
}
.ore-img {
  width: 44px;
  height: 44px;
  object-fit: contain;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.4));
  animation: oreBob 1.6s ease-in-out infinite;
}
.ore-emoji {
  font-size: 42px;
  line-height: 1;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.4));
  animation: oreBob 1.6s ease-in-out infinite;
}
.ore-img-rare {
  animation: oreBob 1.3s ease-in-out infinite, oreGlow 1.8s ease-in-out infinite;
}
@keyframes oreBob {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-6px) rotate(-3deg); }
}
@keyframes oreGlow {
  0%, 100% { filter: drop-shadow(0 0 2px rgba(255,200,80,0.5)); }
  50% { filter: drop-shadow(0 0 10px rgba(255,200,80,0.95)); }
}
.ore-name {
  margin-top: 2px;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
  text-shadow: 0 1px 3px rgba(0,0,0,0.7);
}
.ore-tag {
  display: inline-block;
  margin-left: 4px;
  padding: 0 5px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 15px;
  background: rgba(255,255,255,0.9);
  border: 1px solid;
  vertical-align: 1px;
}
.scene-text {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #f5e8d8;
  text-shadow: 0 1px 2px rgba(0,0,0,0.6);
  padding: 0 10px;
  z-index: 5;
}
.success-text { color: #a5ffa5; }
.fail-text { color: #ffb3b3; }
.result-detail { font-size: 12px; opacity: 0.85; }
/* 熟练度增量徽标：让"挖到东西涨熟练度"看得见 */
.result-mastery {
  font-size: 12px;
  font-weight: bold;
  color: #67c23a;
  border: 1px solid #67c23a;
  border-radius: 8px;
  padding: 0 6px;
  margin-left: 4px;
  line-height: 16px;
  display: inline-block;
}
.rare-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 0 6px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 16px;
  background: #fff3e0;
  color: #e6a23c;
  border: 1px solid #e6a23c;
}
/* 力度条（场景内浮层，不参与文档流布局） */
.power-wrap {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  width: 72%;
  z-index: 3;
  background: rgba(30, 20, 12, 0.82);
  border-radius: 10px;
  padding: 8px 12px 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.35);
}
.power-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}
.power-label {
  font-size: 13px;
  font-weight: bold;
  color: #ffc46b;
}
.power-tip {
  font-size: 12px;
  color: #cbb9a5;
}
.powerbar {
  position: relative;
  height: 20px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #6e5a44;
  background: repeating-linear-gradient(90deg, #b3906f, #b3906f 8px, #a3815f 8px, #a3815f 16px);
}
.powerbar-best {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 55%;
  width: 30%;
  background: repeating-linear-gradient(90deg, #81e08b, #81e08b 8px, #5fd46b 8px, #5fd46b 16px);
}
.powerbar-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 196, 107, 0.35);
  transition: width 0.03s linear;
}
.powerbar-fill.powerbar-perfect {
  background: rgba(95, 212, 107, 0.45);
}
.powerbar-marker {
  position: absolute;
  top: -2px;
  bottom: -2px;
  width: 4px;
  margin-left: -2px;
  background: #fff;
  border-radius: 2px;
  z-index: 2;
}
/* 装备信息 */
.gear-info { margin-top: 10px; text-align: left; padding: 0 6px; }
.gear-row { margin-bottom: 6px; display: flex; align-items: center; flex-wrap: wrap; }
.gear-label { font-size: 13px; color: #555; margin-right: 4px; }
.gear-chip {
  display: inline-block;
  margin: 0 4px;
  padding: 4px 12px;
  border-radius: 12px;
  background: #eef7ee;
  border: 1px solid #b8dcb8;
  color: #406e40;
  font-size: 13px;
}
.gear-chip.gear-missing {
  background: #fdf0f0;
  border-color: #e3b3b3;
  color: #c05656;
}
.gear-pick-row {
  display: block;
}
.pick-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}
.pick-card {
  flex: 1 1 240px;
  max-width: 320px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px 10px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.15s;
  background: #fafafa;
}
.pick-card:hover {
  border-color: #a0764a;
  background: #fdf8f2;
}
.pick-card.pick-selected {
  background: #f5ead9;
  border-color: #a0764a;
  box-shadow: 0 0 0 1px #a0764a;
}
.pick-card-head {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.pick-card-name {
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.pick-using {
  margin-left: 6px;
  font-size: 11px;
  color: #7a5a34;
  background: #fff;
  border: 1px solid #a0764a;
  border-radius: 8px;
  padding: 0 6px;
  line-height: 16px;
}
.pick-card-price {
  margin-left: auto;
  font-size: 12px;
  color: #e6a23c;
  font-weight: bold;
}
.pick-card-attrs {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 8px;
  margin-bottom: 4px;
}
.pick-attr {
  font-size: 12px;
  color: #606266;
  background: #fff;
  border-radius: 8px;
  padding: 1px 6px;
  line-height: 16px;
}
.pick-card.pick-selected .pick-attr {
  background: #faf5ec;
}
.pick-card-foot {
  font-size: 12px;
  color: #909399;
}
.pick-empty {
  display: inline-block;
}
.bait-bonus {
  font-size: 12px;
  color: #909399;
  margin-left: 6px;
}
.bait-bonus.bait-bonus-on {
  color: #67c23a;
  font-weight: bold;
}
.mine-actions { margin-top: 12px; text-align: center; }
/* 敲击蓄力按钮：禁止触摸手势抢占（滚动/长按菜单），保证按住期间 pointer 事件只归按钮 */
.strike-hold-btn {
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
}
.perfect-text {
  color: #ffe066 !important;
  font-weight: bold;
}
.noHandbook { padding: 14px; text-align: center; color: #909399; font-size: 13px; }
/* 图鉴：卡片网格，每格 矿图+名字+采集次数（未采集灰化）——与渔获图鉴同款 */
.hb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 8px;
}
.hb-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px 6px 8px;
  background: #fafafa;
}
.hb-img {
  width: 52px;
  height: 52px;
  object-fit: contain;
}
.hb-name {
  font-size: 13px;
  font-weight: bold;
}
.hb-count {
  font-size: 11px;
  color: #909399;
}
.hb-untagged {
  font-size: 11px;
  color: #bbb;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 6px;
  line-height: 16px;
}
.hb-cell.hb-locked {
  background: #f5f5f5;
}
.hb-locked .hb-img {
  filter: grayscale(1);
  opacity: 0.4;
}
.hb-locked .hb-name {
  color: #bbb !important;
}

/* 挖矿成就（与钓鱼成就同款） */
.ach-stat { font-size: 13px; color: #606266; text-align: center; margin-bottom: 8px; }
.ach-done { color: #67c23a; } .ach-claim { color: #e6a23c; } .ach-got { color: #909399; }
.ach-list { max-height: 320px; overflow-y: auto; }
.ach-item { border: 1px solid #ebeef5; border-radius: 6px; padding: 8px 10px; margin-bottom: 8px; background: #fafafa; }
.ach-item.ach-done-item { border-color: #67c23a; background: #f7fbf2; }
.ach-item.ach-claimed-item { opacity: 0.6; }
.ach-row { display: flex; align-items: center; gap: 8px; }
.ach-name { font-size: 14px; font-weight: bold; color: #303133; flex: 1; }
.ach-progress { font-size: 12px; color: #c0c4cc; }
.ach-progress-done { color: #67c23a; }
.ach-btn { font-size: 12px; padding: 2px 10px; border-radius: 11px; border: none; cursor: pointer; background: #dcdfe6; color: #606266; }
.ach-btn.ach-btn-claim { background: #e6a23c; color: #fff; }
.ach-btn.ach-btn-done { background: #67c23a; color: #fff; }
.ach-btn:disabled { cursor: default; }
.ach-desc { font-size: 12px; color: #909399; margin-top: 4px; }
.ach-reward { color: #e6a23c; }

/* 移动端适配 */
@media (max-width: 768px) {
  .mine-scene { height: 170px; }
  .rock-wall { width: 150px; height: 120px; top: 14px; }
  .power-wrap { width: 84%; }
  /* 图鉴弹窗：网格紧凑化 */
  .hb-grid { gap: 6px; }
  .hb-cell { padding: 6px 4px 5px; }
  .hb-img { width: 44px; height: 44px; }
  .hb-name { font-size: 12px; }
}
</style>
